import { render } from "./Textarea.vue?vue&type=template&id=19385730"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
script.render = render

export default script